import useDocumentTitle from '../hooks/useDocument';
import {Link} from 'react-router-dom';
import Header from '../components/header';
import Breadcrumb from '../components/breadcrumb';
import Features from '../components/features';
import CallToAction from '../components/calltoaction';
import Footer from '../components/footer';

function NeurologicalView() {
  useDocumentTitle('Neurological conditions-Quality-Home-Healthcare');
  return (
    <div className="body-wrapper">
      <Header />
      <Breadcrumb image={'bg-image-22'} title={'Neurological Conditions'} />

      <div className="ltn__page-details-area ltn__service-details-area mb-105">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <h2 className="text-left compassion">
                Excellent standards of personalized care and support in your
                home
              </h2>
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <p className="values_p">
                  {' '}
                  <span className="ltn__first-letter">W</span>e support clients
                  who have a range of neurological conditions and needs that
                  generally result from damage to the brain. Presently in the
                  UK, motor neuron disease affects up to 5,000 people, multiple
                  sclerosis affects around 120,000 people, Parkinson's affects
                  around 145,000 people, and other 600 neurological conditions
                  affect around 10,000 people.
                </p>
                <p>We currently support clients with conditions such as:</p>
                <div>
                  <ul className="care_bullets-2">
                    <li>Motor Neurone Disease</li>
                    <li className="">Huntington’s Disease</li>
                    <li>Cerebral Palsy</li>
                    <li>Locked In Syndrome</li>
                    <li>Muscular Dystrophy</li>
                    <li>
                      Providing respite and additional support to your family.
                    </li>
                    <li>Multiple Sclerosis</li>
                    <li>Parkinson’s Disease</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <h2 className="text-center compassion">Also see:</h2>
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    <li>
                      <Link to="/brain-injury">
                        Brain injury
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/how-we-deliver">
                        How we deliver our care
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/spinal-injury">
                        Spinal injury
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
      <div className="call-to-action-area call-to-action-5  bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">
                  Creating your bespoke package of care
                </h2>
                <p className="white-color">
                  When creating a bespoke care package, we work with you and
                  your family, where appropriate, along with multidisciplinary
                  teams to create a support service that meets your clinical,
                  social, and personal needs.
                </p>
                <p className="white-color">
                  We also consider the practical and clinical elements of your
                  care, along with the emotional and social support aspects of
                  your daily life.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">The way we support you</h2>
                <p>
                  The experience we have delivering care for people with
                  neurological conditions has equipped us to support our clients
                  and their families on an ongoing basis.
                </p>
                <p>
                  The care we can provide to you at home includes the following:
                </p>
                <div>
                  <ul className="care_bullets-2">
                    <li>
                      Diet, nutritional intake and fluid intake, feeding and
                      swallowing PEG feeding/gastrostomy care.
                    </li>
                    <li className="">Tracheostomy care.</li>
                    <li>
                      Respiratory function, respiratory symptoms and
                      ventilation.
                    </li>
                    <li>Support with mobility and accessing the community.</li>
                    <li>Personal care.</li>
                    <li>
                      Moving and handling, supporting muscle problems, weakness.
                    </li>
                    <li>Pain management</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 compassion-bg pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">
                  What a degenerative or neurological condition is
                </h2>
                <p className="white-color">
                  People with neurological diseases can experience a wide range
                  of symptoms as these diseases advance. We customize the way we
                  offer care based on the symptoms that are unique to each of
                  our client's needs. To improve mobility, activities of daily
                  living, swallowing, and communication, we adhere to NICE
                  recommendations and neuro therapists' suggested tactics.
                </p>
                <p className="white-color">
                  Although the life expectancy of a person with a neurological
                  condition varies considerably, these conditions are fatal. A
                  select few people survive for several decades or even longer.
                  Therefore, depending on their specific care needs, the care
                  needed for someone living with these types of conditions can
                  be complicated and varied. Some of our clients can continue to
                  live as independently as possible with the help of a small
                  care team that helps them with daily chores. Others may need
                  more involved interventions and round-the-clock assistance.
                  Whatever your needs, we can make it easier for you to live
                  comfortably at home.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">
                  Living with a neurological condition
                </h2>
                <p className="">
                  Neurological conditions can have a significant impact on an
                  individual's ability to perform day-to-day activities by
                  impairing key functions such as speech, communication,
                  mobility, and movement.
                </p>
                <p>
                  The condition can cause weakness in the chest, tongue, lips,
                  and vocal cords, which can, in turn, affect facial expression
                  and gestures as well as spoken communication. Over time,
                  symptoms gradually get worse. Treatments such as a feeding
                  tube or breathing air through a face mask may be required as
                  the difficulty of moving, swallowing, and breathing increases.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left"></div>
            </div>
          </div>
        </div>
      </div>
      <Features
        icon1="fas fa-chevron-right"
        icon2="fas fa-volume-up"
        text1=" Combining skills, expertise and knowledge to offer quality
                  care."
        text2="Read what our customers have to say about us.
        "
        link1="/team"
        link2="/testimonials"
        btn1="Meet our team"
        btn2="Read our testimonials"
      />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default NeurologicalView;
